import React from "react";
import { Link } from "react-router-dom";
import bannerImg from "../../assets/home/radiomonitor-site.jpg";
import { authFetch } from "../../authFetch";

const PUB = process.env.PUBLIC_URL + "/assets/home";
const roleOwner = `${PUB}/role-owner.svg`;
const roleProgram = `${PUB}/role-program.svg`;
const roleTech = `${PUB}/role-tech.svg`;
const rolePromo = `${PUB}/role-promo.svg`;
const roleSales = `${PUB}/role-sales.svg`;
const markGreen = `${PUB}/mark-green.svg`;
const presentationIcon = `${PUB}/icon_doc.svg`;
const arrowIcon = `${PUB}/arrow.svg`;
const moreLinkLayout = {
  stats: { marginTop: 32, display: "flex", justifyContent: "flex-end" },
  silence: { marginTop: 32, display: "flex", justifyContent: "flex-end" },
  link: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    color: "#006b44",
    fontSize: 16,
    fontWeight: 400,
    textDecoration: "none"
  },
  icon: { width: 19, height: 19, display: "block" }
};
const pricingStats = `${PUB}/pricing-stats.svg`;
const pricingMonitor = `${PUB}/pricing-monitor.svg`;
const presentationItLink = 'https://docs.google.com/presentation/d/1VnRGCERjE1_3sAvxfHBoKoGVwq_MhDEBVD2B7BlZUP4/edit?usp=sharing';

const HERO_ROLES = [
  "proprietari di stazioni radio",
  "direttori di programmazione",
  "direttori tecnici (ingegneria)",
  "reparto promozione dell’emittente",
  "team vendita pubblicitaria",
];

const CLIENT_LOGOS = [
  process.env.PUBLIC_URL + "/assets/home/001_Logo_Rodynne.svg",
  process.env.PUBLIC_URL + "/assets/home/004_Logo_Prishepkin.svg",
  process.env.PUBLIC_URL + "/assets/home/003_Logo_Karamelka.svg",
  process.env.PUBLIC_URL + "/assets/home/004_Logo_Baba.svg",
];
const SUCCESS_FEATURES = [
  "Palinsesto e break: pianificazione efficace.",
  "Dati trasparenti, pronti per gli inserzionisti",
  "Un quadro chiaro di crescita e fidelizzazione dell’audience",
  "Garanzia che l’on-air non si fermi a tua insaputa",
];
const FEATURE_DOT_SIZE = 20;
const FEATURE_DOT_COLOR = "#006b44";
const featureDotStyle = (size = FEATURE_DOT_SIZE) => ({
  width: size,
  height: size,
  borderRadius: 999,
  background: FEATURE_DOT_COLOR,
  display: "inline-block",
});

function ClientsCarousel() {
  const logos = CLIENT_LOGOS;
  const vis = 4;
  const step = 100 / vis;
  const [idx, setIdx] = React.useState(0);
  const [anim, setAnim] = React.useState(true);

  const track = React.useMemo(() => [...logos, ...logos.slice(0, vis)], [logos, vis]);

  React.useEffect(() => {
    const t = setInterval(() => setIdx((i) => i + 1), 3500);
    return () => clearInterval(t);
  }, [logos.length]);

  const onTransitionEnd = () => {
    if (idx >= logos.length) {
      setAnim(false);
      setIdx(0);
      setTimeout(() => setAnim(true), 20);
    }
  };

  const prev = () => {
    if (idx === 0) {
      setAnim(false);
      setIdx(logos.length);
      setTimeout(() => {
        setAnim(true);
        setIdx(Math.max(logos.length - 1, 0));
      }, 20);
    } else {
      setIdx((i) => i - 1);
    }
  };

  const next = () => setIdx((i) => i + 1);

  if (!logos.length) return null;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 16, margin: "8px 0 14px" }}>
      <button
        type="button"
        onClick={prev}
        aria-label="Назад"
        style={{
          width: 36,
          height: 36,
          borderRadius: 999,
          border: "1px solid #cfd5d1",
          background: "#fff",
          cursor: "pointer",
          fontSize: 20,
          lineHeight: "34px",
        }}
      >
        ‹
      </button>

      <div style={{ overflow: "hidden", flex: "1 1 auto" }}>
        <div
          onTransitionEnd={onTransitionEnd}
          style={{
            display: "flex",
            transform: `translateX(-${idx * step}%)`,
            transition: anim ? "transform 900ms ease" : "none",
            willChange: "transform",
          }}
        >
          {track.map((src, i) => {
            const isPrishepkin = src.includes("004_Logo_Prishepkin.svg");
            return (
              <div
                key={src + i}
                style={{
                  flex: `0 0 ${step}%`,
                  padding: "0 26px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxSizing: "border-box",
                }}
              >
                <img
                  src={src}
                  alt=""
                  style={{
                    maxWidth: isPrishepkin ? 195 : 130,
                    width: "100%",
                    height: "auto",
                    display: "block",
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>

      <button
        type="button"
        onClick={next}
        aria-label="Вперед"
        style={{
          width: 36,
          height: 36,
          borderRadius: 999,
          border: "1px solid #cfd5d1",
          background: "#fff",
          cursor: "pointer",
          fontSize: 20,
          lineHeight: "34px",
        }}
      >
        ›
      </button>
    </div>
  );
}

export default function HomeUk({ isAuth }) {
  const [statsPriceEUR, setStatsPriceEUR] = React.useState(null);
  const [monitorPriceEUR, setMonitorPriceEUR] = React.useState(null);
  React.useEffect(() => {
    let cancelled = false;
    Promise.all([
      authFetch("/products/STATS/price-uah").then((r) => (r.ok ? r.json() : Promise.reject(r.status))),
      authFetch("/products/MONITORING/price-uah").then((r) => (r.ok ? r.json() : Promise.reject(r.status))),
    ])
      .then(([stats, monitoring]) => {
        if (cancelled) return;
        setStatsPriceEUR(typeof stats?.price_eur === "number" ? stats.price_eur : null);
        setMonitorPriceEUR(typeof monitoring?.price_eur === "number" ? monitoring.price_eur : null);
      })
      .catch(() => {
        if (cancelled) return;
        setStatsPriceEUR(null);
        setMonitorPriceEUR(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  const statsPriceText =
    statsPriceEUR !== null ? `${Math.ceil(statsPriceEUR).toLocaleString("it-IT")} €/mese` : "— €/mese*";
  const monitorPriceText =
    monitorPriceEUR !== null ? `${Math.ceil(monitorPriceEUR).toLocaleString("it-IT")} €/mese` : "— €/mese";
  return (
    <div
      style={{
        width: "100%",
        minHeight: 0,
        display: "flex",
        justifyContent: "center",
        paddingTop: 0,
        paddingBottom: "clamp(16px, 4vw, 32px)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 1100,
          paddingTop: 0,
          paddingRight: "clamp(16px, 5vw, 48px)",
          paddingBottom: "clamp(16px, 5vw, 48px)",
          paddingLeft: "clamp(16px, 5vw, 48px)",
          boxSizing: "border-box",
          color: "#2e2e2e",
          lineHeight: 1.6,
          fontSize: 16,
          wordBreak: "break-word",
          overflowWrap: "anywhere",
        }}
      >
        <img
          src={bannerImg}
          alt=""
          style={{ width: "100%", height: "auto", display: "block", marginBottom: 24 }}
        />
        {/* === Блок 1: Аналітика та моніторинг (герой + цільові ролі) === */}
        <section style={{ margin: "0 0 28px" }}>
          <h2 style={{ fontSize: 42, fontWeight: 900, color: "#006b44", margin: 0 }}>
            Analisi e monitoraggio per le stazioni<br />radio online
          </h2>

          <p style={{ margin: "16px 0 10px", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> - Un servizio moderno per le stazioni radio online che 
            combina analisi dettagliate del pubblico e monitoraggio tecnico 24/7 della messa in onda
          </p>
          <p style={{ margin: "0 0 24px", fontSize: 18 }}>
            Ottieni dati trasparenti e verificabili sull’audience, dimostra agli inserzionisti 
            la copertura verificata e mostra l’efficacia dei tuoi break pubblicitari
          </p>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5, 1fr)",
              gap: 0,
              alignItems: "start",
              paddingTop: 8,
            }}
          >
            {HERO_ROLES.map((label, index) => (
              <div
                key={label}
                style={{
                  textAlign: "center",
                  padding: "0 24px",
                }}
              >
                <img
                  src={[roleOwner, roleProgram, roleTech, rolePromo, roleSales][index]}
                  alt={label}
                  style={{
                    width: 120,
                    height: 120,
                    display: "block",
                    margin: "0 auto 10px",
                    objectFit: "contain",
                  }}
                />
                <div style={{ color: "#006b44", fontWeight: 400 }}>{label}</div>
              </div>
            ))}
          </div>

          <p style={{ margin: "24px 0 0", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> - Una soluzione per broadcaster che 
            vogliono piena visibilità sulla propria audience e certezza della stabilità on-air
          </p>
          <div
            style={{
              marginTop: 18,
              display: "inline-flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <img
              src={presentationIcon}
              alt=""
              style={{ width: 22, height: 22 }}
              aria-hidden="true"
            />
            <a
              href={presentationItLink}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#006b44",
                textDecoration: "none",
                fontSize: 18,
                fontWeight: 700,
              }}
            >
              Apri la presentazione di <span style={{ fontWeight: 800 }}>Radiomonitor.net</span>
            </a>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 2: Статистика слухачів інтернет-радіо === */}
        <section style={{ margin: "36px 0 16px" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 8px" }}>
            <Link to="service/stats#stats-hero" style={{ color: "inherit", textDecoration: "none", display: "inline-block" }}>
              Analytics dell’audience per la radio online
            </Link>
          </h2>
          <p style={{ margin: "0 0 16px", fontSize: 18 }}>
            Raccogli dati che fanno girare il tuo business. Con <strong>Radiomonitor.net</strong> sai sempre chi ti ascolta e in quale momento esatto
          </p>
          <ul style={{ margin: 0, paddingLeft: 24, fontSize: 18 }}>
            <li>Ascoltatori unici e sessioni</li>
            <li>Geografia e dispositivi</li>
            <li>Orari di picco e prime time</li>
            <li>TSL (tempo medio di ascolto)</li>
            <li>Nuovi ascoltatori, retention e fidelizzazione</li>
            <li>Top-40 e statistiche pubblicitarie</li>
          </ul>

          <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginTop: 28 }}>
            <img
              src={markGreen}
              alt=""
              style={{
                width: 72,
                height: 72,
                borderRadius: 8,
                flex: "0 0 auto",
                transform: "translateY(10px)",
              }}
            />
            <div style={{ fontSize: 18 }}>
              <div style={{ fontWeight: 800, marginBottom: 6 }}>Funzionalità aggiuntive:</div>
              <div>- Tracciamento degli ascoltatori di uno specifico spot pubblicitario</div>
              <div>- Generazione automatica della TOP-40 dalla rotazione</div>

            </div>
          </div>
          <div style={moreLinkLayout.stats}>
            <Link to="service/stats#stats-hero" style={moreLinkLayout.link}>
              di più
              <img src={arrowIcon} alt="" style={moreLinkLayout.icon} />
            </Link>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 3: Цілодобовий контроль ефіру === */}
        <section style={{ margin: "36px 0 16px" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 8px" }}>
            <Link to="service/silence" style={{ color: "inherit", textDecoration: "none", display: "inline-block" }}>
              Monitoraggio on-air 24/7
            </Link>
          </h2>
          <p style={{ margin: "0 0 16px", fontSize: 18 }}>
            Il tuo on-air è sempre sotto controllo. <strong>Radiomonitor.net</strong> rileva i silenzi e avvisa immediatamente in caso di guasti
          </p>
          <ul style={{ margin: 0, paddingLeft: 24, fontSize: 18 }}>
            <li>Monitoraggio dei flussi 24/7 (MP3 e HE-AAC/AAC+)</li>
            <li>Avvisi immediati su Telegram</li>
            <li>Storico dei livelli audio per 7 giorni</li>
          </ul>

          <div style={{ display: "flex", gap: 16, alignItems: "flex-start", marginTop: 28 }}>
            <img
              src={markGreen}
              alt=""
              style={{
                width: 72,
                height: 72,
                borderRadius: 8,
                flex: "0 0 auto",
                transform: "translateY(13px)",
              }}
            />
            <div style={{ fontSize: 18 }}>
              <div style={{ fontWeight: 800, marginBottom: 6 }}>Vantaggi:</div>
              <div>- Configurazione semplice, senza hardware aggiuntivo</div>
              <div>- Fino a 3 contatti per ricevere gli avvisi</div>
            </div>

          </div>
          <div style={moreLinkLayout.silence}>
            <Link to="service/silence" style={moreLinkLayout.link}>
              di più
              <img src={arrowIcon} alt="" style={moreLinkLayout.icon} />
            </Link>
          </div>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 4: Слоган + 4 колонки переваг === */}
        <section style={{ margin: "40px 0 8px" }}>
          <h2
            style={{
              fontSize: 40,
              fontWeight: 900,
              color: "#006b44",
              margin: "0 0 27px",
              lineHeight: 1.2,
            }}
          >
            Radiomonitor.net
            <br />
            - tutto per il successo della tua radio online
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 24,
              alignItems: "start",
              marginBottom: 12,
              textAlign: "center",
              fontWeight: 700,
              fontSize: 18,
            }}
          >
            {SUCCESS_FEATURES.map((text) => (
              <div
                key={text}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <span style={featureDotStyle()} />
                <span>{text}</span>
              </div>
            ))}
          </div>
          <p style={{ margin: 0, fontSize: 18 }}>Siate un passo avanti alla concorrenza già da oggi!</p>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 4.1: Карусель логотипів (клієнти) === */}
        <section style={{ margin: "32px 0 0" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 3px" }}>
            Radiomonitor.net
          </h2>
          <h3
            style={{
              fontSize: 40,
              fontWeight: 900,
              color: "#006b44",
              margin: "0 0 12px",
              lineHeight: 0.8,
            }}
          >
            scelto dalle principali radio online
          </h3>

          <p style={{ margin: "0 0 18px", fontSize: 18 }}>
            <strong>Radiomonitor.net</strong> - un servizio internazionale di analytics e 
            monitoraggio on-air, già utilizzato dalle principali radio online. Aiutiamo 
            le web radio di qualsiasi Paese a ottenere statistiche precise dell’audience, 
            dati trasparenti per gli inserzionisti e la garanzia di un on-air stabile
          </p>

          <ClientsCarousel />

          <p style={{ margin: 0, fontSize: 18 }}>
            Ci farebbe piacere vedere anche il tuo logo qui. Unisciti a Radiomonitor.net 
            da qualsiasi parte del mondo
          </p>
        </section>
        <div style={{ height: 1, background: "#006b44", opacity: 0.35, margin: "24px 0" }} />

        {/* === Блок 5: Цінові пакети === */}
        <section style={{ margin: "40px 0 0" }}>
          <h2 style={{ fontSize: 40, fontWeight: 900, color: "#006b44", margin: "0 0 24px" }}>
            Piani tariffari di Radiomonitor.net
          </h2>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 40,
              alignItems: "start",
              marginBottom: 24,
            }}
          >
            <div style={{ textAlign: "center" }}>
              <img
                src={pricingStats}
                alt=""
                style={{ width: 160, height: 160, borderRadius: 12, marginBottom: 12 }}
              />
              <div style={{ fontWeight: 800, fontSize: 22, marginBottom: 8 }}>Abbonamento alle statistiche di ascolto*</div>
              <div style={{ fontWeight: 800, fontSize: 32, color: "#006b44" }}>{statsPriceText}</div>
            </div>
            <div style={{ textAlign: "center" }}>
              <img
                src={pricingMonitor}
                alt=""
                style={{ width: 160, height: 160, borderRadius: 12, marginBottom: 12 }}
              />
              <div style={{ fontWeight: 800, fontSize: 22, marginBottom: 8 }}>Abbonamento al monitoraggio dei silenzi**</div>
              <div style={{ fontWeight: 800, fontSize: 32, color: "#006b44" }}>{monitorPriceText}</div>
            </div>
          </div>
          <p style={{ margin: '12px 0 12px', fontSize: 14 }}>
            *Raccolta, conservazione e elaborazione dei dati da un singolo stream, 24/7, accesso ai dati per una persona
            <br />
            **Monitoraggio di un singolo stream 24/7, uso del bot Telegram per 1+2 persone
          </p>
          <p style={{ margin: '12px 0 0', fontSize: 18 }}>
            Vuoi provarlo? Invia una richiesta oppure registra subito la tua stazione!
          </p>
        </section>
      </div>
    </div>
  );
}
